import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";


import back from "../../back.png";
import InputText from "../../helpers/InputText";
import InputDate from "../../helpers/InputDate";
import InputCombo from "../../helpers/InputCombo";

import CorrespForm from "./CorrespForm";

function PostReview(props)
{
  const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var dt = new Date();
    dt = dt.toLocaleDateString('en-CA');
    dt = "" + dt.substring(0,7) + "-01";


  const [cors, setCors] = useState(null); //korespondencji..
  const [post_typ, setPostTyp] = useState(null); //typ przesylki...

  const [errTab, setErrTab] = useState([]); 
  const [row, setRow] = useState({

        id: -1,
        numer_dokumentu:'',
        rodzaj: props.detTyp, //przychodzaca, wychodzaca..
        status: 'niezatwierdzona',
        data: dt,
        id_poczta_sl_operatorzy: '3',

        pozycji: 1,
        pozycje: [
                { id:-1,  id_poczta_kontrahenci: '-1', id_poczta_sl_przesylek: -1, numer: '' , det: []}                                                                                              
        ],
   });

    var tmpRow = row;

    

    const [goNew,setGoNew] = useState(null);
    const [goEdit,setGoEdit] = useState(null);

 
    
    const valChangeListener = (filedName, val, correct, msg) => {   
        
              
        
                console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 3)
                {                    
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tabCol  = tabCheck[2];

                    if(tabCol == "id_poczta_kontrahenci" && val == -2)
                    {
                        setGoNew(tabInx);
                        return;
                    }

                    var tRef = row[tabName];

                    if(correct)tRef[tabInx][tabCol] = val;
                    if(!correct)tRef[tabInx][tabCol] = "";

                    tmpRow[tabName] = tRef;     

                
                    
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );           
                    return;
                }
                    
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         
               
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );        
               
                if(filedName == 'data')
                getNextNum(val);
            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const addItem = () => {
        setRow( { ...row, ['pozycji']: row.pozycji+1 } );
    }

    
    const getCorresp = () => {
        
        props.mainView.showProgress();       

        fetch( Config.url + '/rest_v1_post,corresp_combo', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setCors(res.result);                                     
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }

    
     const getPostCat = () => {
        
        props.mainView.showProgress();       

        fetch( Config.url + '/rest_v1_post,post_cat_combo', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setPostTyp(res.result);                                     
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }

     const getNextNum = (dataDef) => {
        
        props.mainView.showProgress();       


        var dt = row.data;
        if(dataDef != undefined && dataDef != null) dt = dataDef;


        fetch( Config.url + '/rest_v1_post,post_next_num', {
            method: 'POST', 
            body: JSON.stringify({
                rodzaj: row.rodzaj,
                data: dt,
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow({...row, ["numer_dokumentu"]: res.result });               
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }



    const getDet = (idx) => {
        
        props.mainView.showProgress();       

        fetch( Config.url + '/rest_v1_post,post_get', {
            method: 'POST', 
            body: JSON.stringify({
                id: idx
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                    
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }
    
    const saveData = () => {
        

        if(!valChecker(row))
        {
               
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza  " ,  "error"  ,null); 
                return;
        }

        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_post,post_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                //props.onSuccess(res.result);  //przekaz id Firmy 
                                getDet(res.result);
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



        
    const goDownload = (e) => {

         var id = e.target.getAttribute('atr-id');
         var title = "ksiazka";

         var fileName = title.replace(/[/]/g,"_") + ".pdf";

         var links = [
            {
                link: '/rest_v1_post,pdf',
                typ: 'pdf',
                fileName:  fileName,
                params: {
                    id: id
                },
            }
         ];

         if(Config.env == 'dev') console.log("goDownload", id, title);
         props.mainView.downloadDialog(links);
    }


    const openEdit = (e) => {
        var id = e.target.getAttribute('atr-id');
        var inx = e.target.getAttribute('atr-inx');
        setGoEdit({
            id: id,
            inx: inx,
        });
    }


    const closeDialogX = () => {
        setGoNew(null);
        setGoEdit(null);
    }


    const setEditedClient = (id) => {
        getCorresp();  
        setGoEdit(null);
    }


    const setNewClient = (id) => {

        getCorresp();

        var inx = parseInt(goNew) ;
        setGoNew(null);
 

        //----------------------
       
                    var tRef = row.pozycje;       
                    tRef[inx]["id_poczta_kontrahenci"] = id;       
                    tmpRow["pozycje"] = tRef;                                         
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );           
                    return;

    }




   const keyListener = (e) => {
                       var code = e.keyCode ? e.keyCode : e.which;    

                    console.log("EEE", code);

                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )     //backslashe                                             
                        {                            
                            if(props.onBack != undefined)  props.onBack();
                        }else  
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();                          
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                          
                        }else                           
                        {
                            props.keyListener(e);
                        }
   }



   useEffect( ()=>{

            if(Config.env == "dev") console.log("PostReview.js, listener on");
            window.onkeydown = keyListener; 

            return () => {   
                 if(Config.env == "dev") console.log("PostReview.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );




    if(cors == null)
    {
        setCors([]);
        getCorresp();
        getPostCat();      
        getNextNum();

        return <div>....</div>
    }


      if(props.id > 0 && row.id < 0)
        {
            getDet(props.id);
            return <div>......</div>
        }

     
    var dialogBox = null;
    
    if(goNew != null)
    {
            dialogBox = <div className="dlg_window dlg_type_x shadowx " >

                <div className="dlg_title" >Nowy korespondent</div>

                  <div className="dlg_content_white" >
                      <CorrespForm  userData={props.userData} mainView={props.mainView}   keyListener={keyListener} onBack={closeDialogX}   onSuccess={setNewClient}  id={-1} backbtn="0" />
                  </div>

            </div>
    }


    if(goEdit != null)
    {
            dialogBox = <div className="dlg_window dlg_type_x shadowx " >

                <div className="dlg_title" >Edycja danych korespondenta</div>

                  <div className="dlg_content_white" >
                      <CorrespForm  userData={props.userData} mainView={props.mainView}   keyListener={keyListener} onBack={closeDialogX}   onSuccess={setEditedClient}  id={goEdit.id} backbtn="0" />
                  </div>

            </div>
    }



    return <div className="view_content">
                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                    <div className="app_header">Szczegóły</div>

                    <form className="eForm bg_center">

                            <div className="form_tab_title">Informacje podstawowe:</div>

                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Status</div>
                                                <InputCombo items={[ {v:'niezatwierdzona', title:'Wersja robocza'}, {v:'zatwierdzona', title:'Gotowa, zatwierdzona'},  ]} userData={props.userData} value={row.status} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="status" placeholder={"Numer dokumentu:"} className='  ' req='0' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Numer dokumentu</div>
                                                <InputText   userData={props.userData} value={row.numer_dokumentu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer_dokumentu" placeholder={"Numer dokumentu:"} className='  ' req='0' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Data dokumentu</div>
                                                <InputDate   userData={props.userData} value={row.data} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data" placeholder={"Data:"} className='  ' req='0' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Operator</div>
                                                <InputCombo items={[ {v: 3,title:'Poczta '}, {v: 4,title:'Kurier InPost'}  , {v: 5,title:'poczta - Polecony'} ,  {v: 6,title:'inne, list'} , {v: 7,title:'Kurier DHL'}   ]}  userData={props.userData} value={row.id_poczta_sl_operatorzy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="id_poczta_sl_operatorzy" placeholder={":"} className='  ' req='1' firstUp="1" />
                                            </div>

                            </div>


                            <div className="form_tab_title">Pozycje:</div>
                             <div className="form_tab">
                                    {
                                        row.pozycje.map( (item, ix) => {

                                            if (ix >= row.pozycji) return null;

                                            return <Fragment>


                                                <div className="form_control">
                                                        <div className="fieldName">Korespondent
                                                            {
                                                                item.id_poczta_kontrahenci > 0 &&
                                                                <sup class="link_color" atr-id={item.id_poczta_kontrahenci} atr-inx={ix}  onClick={openEdit} > edytuj </sup>
                                                            }
                                                        </div>
                                                        <InputCombo items={cors}  userData={props.userData} value={item.id_poczta_kontrahenci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={ "pozycje@" + ix + "@id_poczta_kontrahenci" } placeholder={":"} className=' w200 ' req='1' firstUp="1" />
                                                </div>

                                                <div className="form_control">
                                                        <div className="fieldName">Rodzaj / Kategoria</div>
                                                        <InputCombo items={ post_typ }  userData={props.userData} value={item.id_poczta_sl_przesylek} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={ "pozycje@" + ix + "@id_poczta_sl_przesylek" } placeholder={":"} className='   ' req='1' firstUp="1" />
                                                </div>

                                                 <div className="form_control">
                                                        <div className="fieldName">Numer przesyłki</div>
                                                        <InputText  userData={props.userData} value={item.numer} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={ "pozycje@" + ix + "@numer" } placeholder={"Nr przesyłki:"} className=' w200 ' req='0' firstUp="1" />
                                                </div>


                                                <div className="form_split"></div>

                                            </Fragment>

                                        } )
                                    }

                                    <span className="link_color"  onClick={addItem} >dodaj więcej pozycji +</span>
                             </div>
                                            

                                            
                                <div className="form_split"></div>

                                <div className="form_btn">

                                        {
                                            row.id > 0 &&
                                            <Fragment>
                                                    <span className="link_color" atr-id={row.id} onClick={goDownload}> pobierz PDF</span>
                                                    &nbsp; &nbsp;
                                            </Fragment>
                                        }                                        

                                        <div className="btn" onClick={saveData}>zapisz zmiany [ctrl + s ]</div>
                                        &nbsp;&nbsp;                                       
                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                </div>

                    </form>

                    {dialogBox}
    </div>

}


export default PostReview;